export const setQueryToUrl = (query: string): void => {
  const url = new URL(window.location.href);
  url.searchParams.set('q', query);

  const path = url.toString();

  if (window.location.href !== path) {
    window.history.pushState({ path }, '', path);
  }
};
